import React from "react";
import { ChevronLeft, ChevronRight, Image as ImageIcon } from "lucide-react";
import { useSiteContent } from "../admin/SiteContentContext";

export default function PhotoStory() {
  const { content } = useSiteContent();
  const { photoSlides } = content;
  const [i, setI] = React.useState(0);
  const total = photoSlides.length;
  React.useEffect(() => {
    const t = setInterval(() => setI(v => (v+1)%total), 6000);
    return () => clearInterval(t);
  }, [total]);
  const s = photoSlides[i];
  const pad = n => String(n).padStart(2, "0");

  return (
    <section className="py-24 bg-[#080e1c] border-y border-white/5">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
        <div className="relative rounded-3xl overflow-hidden border border-white/10">
          <div className="aspect-[4/3] relative">
            <img key={s.image} src={s.image} alt={s.tag} className="w-full h-full object-cover fade-up" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#070b17] to-transparent" />
            <div className="absolute left-6 bottom-6 right-6">
              <span className="kicker uppercase">{s.tag}</span>
              <p className="font-serif-display text-white text-2xl md:text-3xl mt-2 leading-snug">“{s.quote}”</p>
              <p className="text-sm text-slate-300 mt-2">— Dazile Auguste</p>
            </div>
          </div>
        </div>

        <div>
          <span className="kicker"><ImageIcon className="w-3.5 h-3.5" /> Photo slide story</span>
          <h3 className="font-serif-display text-4xl md:text-5xl text-white mt-4 mb-5">A picture can hold a whole feeling.</h3>
          <p className="text-slate-300 max-w-md mb-8">Explore a growing visual library of health, care, companionship, and everyday support.</p>

          <div className="flex items-center gap-3">
            <button onClick={() => setI((i-1+total)%total)} aria-label="prev"
              className="w-11 h-11 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white hover:bg-white/10 transition">
              <ChevronLeft className="w-5 h-5" />
            </button>
            <button onClick={() => setI((i+1)%total)} aria-label="next"
              className="w-11 h-11 rounded-full bg-[#c7e34a] text-[#0b1220] flex items-center justify-center hover:brightness-105 transition">
              <ChevronRight className="w-5 h-5" />
            </button>
            <span className="text-slate-400 text-sm ml-3">{pad(i+1)} / {pad(total)}</span>
          </div>

          <div className="card-soft mt-10 p-6">
            <p className="font-serif-display text-white text-lg leading-snug">“Healthcare begins with compassion: listen closely, support gently, and help every person feel seen.”</p>
            <p className="text-sm text-slate-400 mt-3">Dazile Auguste · 1-866-545-8868</p>
          </div>
        </div>
      </div>
    </section>
  );
}
